import { memo, useCallback } from 'react';

import {
  workspaceAgentComposerScopeBarOverlay,
  workspaceAgentComposerScopeBarOverlayInner,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentComposerChrome';
import { WorkspaceAgentComposerScopeBar } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/composer/WorkspaceAgentComposerScopeBar';
import { usePrivateWorkspaceAgentComposerScopeChip } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/usePrivateWorkspaceAgentComposerScopeChip';
import { useWorkspaceAgentExpandedAssetView } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentExpandedAssetView';
import { usePrivateWorkspaceAgentPanelComposerPills } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';

export type PrivateWorkspaceAgentComposerScopeBarProps = {
  onAfterRemove?: () => void;
};

export const PrivateWorkspaceAgentComposerScopeBar = memo(
  ({ onAfterRemove }: PrivateWorkspaceAgentComposerScopeBarProps) => {
    const { clearScope } = usePrivateWorkspaceAgentPanelComposerPills();
    const { scopeChip } = usePrivateWorkspaceAgentComposerScopeChip();
    const { isExpandedAssetViewModalSession } = useWorkspaceAgentExpandedAssetView();

    const canRemoveScope = scopeChip?.kind !== 'board' && !isExpandedAssetViewModalSession;

    const handleRemove = useCallback(() => {
      clearScope();
      onAfterRemove?.();
    }, [clearScope, onAfterRemove]);

    if (!scopeChip) {
      return null;
    }

    return (
      <div className={workspaceAgentComposerScopeBarOverlay()}>
        <div className={workspaceAgentComposerScopeBarOverlayInner()}>
          <WorkspaceAgentComposerScopeBar
            kind={scopeChip.kind}
            name={scopeChip.name}
            onRemove={canRemoveScope ? handleRemove : undefined}
            title={scopeChip.title}
          />
        </div>
      </div>
    );
  },
);

PrivateWorkspaceAgentComposerScopeBar.displayName = 'PrivateWorkspaceAgentComposerScopeBar';
